export const isFlaggedOn = (flagName: string, flags: Record<string, boolean>): boolean => !!flags?.[flagName]
